import { Component } from "preact";
import { framesStore } from "../store/frames";

export default class ExternalBlock extends Component {
    shouldComponentUpdate() {
      return false;
    }

    render() {
        return (
            <>
            <div class="zeeg-inline-widget" id="zeeg-embed-durchblick-termin" style="min-width: 320px; height: 780px; margin: 0 -12px;"></div>
            <script type="text/javascript" src="https://assets.zeeg.me/embed.min.js" data-a1={framesStore.dateSubject.value} data-a2={framesStore.reservedFrameList.value.map(f => 'Modell: ' + f.no + ' - ' + f.name.replace('&shy;', '')).join('\n')} data-user="durchblick" data-event-type="termin" data-hide-details="1" async></script>
            </>
        )
    }
}
